import React from 'react'

import { Icon } from '@/components/Icon/Icon'
import { faChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp'
import { Accordion, AccordionDetails, AccordionSummary, styled, Typography } from '@mui/material'

export type FaqAccordionProps = {
  question: string
  answer: string
  expanded?: boolean
  onChange?: (event: React.SyntheticEvent, isExpanded: boolean) => void
}

export const FaqAccordion: React.FC<FaqAccordionProps> = ({
  question,
  answer,
  expanded,
  onChange,
}) => {
  return (
    <StyledAccordion expanded={expanded} onChange={onChange}>
      <StyledAccordionSummary
        expandIcon={<Icon fontSize={'small'} icon={faChevronUp}/>}
      >
        <StyledQuestionText sx={{ fontWeight: '500' }}>{question}</StyledQuestionText>
      </StyledAccordionSummary>
      <StyledAccordionDetails>
        <StyledAnswerText>{answer}</StyledAnswerText>
      </StyledAccordionDetails>
    </StyledAccordion>
  )
}

export const StyledAnswerText = styled(Typography)(( { theme }) => ({
  color: theme.palette.primary.main,
}))


export const StyledQuestionText = styled(Typography)(( { theme }) => ({
  color: theme.palette.primary.main,
}))

export const StyledAccordion = styled(Accordion)(() => ({
  boxShadow: 'none',
  backgroundColor: 'transparent',
  '&:before': { display: 'none' },
}))

export const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  '&:focus':
    { outline: 'none' },
  padding: 0,
  backgroundColor: 'transparent',
  color: theme.palette.primary.main,

  '&.Mui-expanded': {
    backgroundColor: 'transparent',
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    color: theme.palette.primary.main,
  },
}))

export const StyledAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  color: theme.palette.primary.main,
  backgroundColor: 'transparent',
  '& .MuiTypography-root': {
    lineHeight: 1.4,
  },
}))